export default __webpack_public_path__ + "static/media/frappuccino-640w.d08ef616.jpg";